import React from 'react';

import Typography from '../../library/typography/typography';
import { CheckSolidIcon, TimesSolidIcon } from '../../shared/icons/icons';

import { ProductData } from '../../shared/types/graphql-types';
import { ARTICLE_STATUSES } from '../../shared/constants/products';

import './product-article-status-banner.scss';

interface ProductArticleStatusBannerProps {
  className?: string;
  product: ProductData;
  showCheckMark?: boolean;
}

function ProductArticleStatusBanner(props: ProductArticleStatusBannerProps) {
  const {
    className,
    product: { articleStatus, articleStatusLabel, productLaunchDate } = {},
    showCheckMark = true
  } = props;

  return (
    <div
      className={`${className || ''} product-article-status-banner`}
      styleName="container"
    >
      {(articleStatus === ARTICLE_STATUSES.DISCONTINUED ||
        articleStatus === ARTICLE_STATUSES.BACKORDER ||
        articleStatus === ARTICLE_STATUSES.QUALITY_HOLD ||
        articleStatus === ARTICLE_STATUSES.TEMPORARILY_UNAVAILABLE) && (
        <TimesSolidIcon styleName="icon-discontinued" />
      )}
      {articleStatus === ARTICLE_STATUSES.PRE_LAUNCH && showCheckMark && (
        <CheckSolidIcon styleName="icon-prelaunch" />
      )}
      <Typography
        className="product-article-status-banner__label"
        styleName="label"
        tag="strong"
        weight="bold"
      >{`${articleStatusLabel}${
        productLaunchDate && articleStatus === ARTICLE_STATUSES.PRE_LAUNCH
          ? `: ${productLaunchDate}`
          : ''
      }`}</Typography>
    </div>
  );
}

export default ProductArticleStatusBanner;
